/**
 * Class description
 *
 * Created: 2017-09-22
 * @author jonas
 */
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";

export class DirtyWildsTextStyles {

    public static WIN_DISPLAY_NUMBERS:BitmapTextStyleOptions = {
        font : {
            name : "winCountUpNumbers",
            size : 180
        },
        tint : 0xffffff
    };

    public static WIN_DISPLAY_NUMBERS_WHITE:BitmapTextStyleOptions = {
        font : {
            name : "winCountUpNumbersWhite",
            size : 180
        },
        tint : 0xffffff
    };

    public static WIN_DISPLAY_MULTIPLIER_TEXT = {
        fontName : "multiplierNumbers",
        fontSize : 80,
        tint : 0xffffff
    };

    static TOP_BAR_NUMBER_STYLE = {
        fontName : "multiplierNumbers",
        fontSize : 40,
        tint : 0xffffff
    };

    static TOP_BAR_NUMBER_STYLE_FS = {
        fontName : "firespinNumbers",
        fontSize : 40,
        tint : 0xffffff
    };


}